/**
 * Flags de negocio del front.
 *
 * Se leen de `process.env.REACT_APP_*` (CRA las inlinea en build time) con un
 * default que refleja el estado actual del producto, para que la app funcione
 * sin configurar nada. Para cambiarlas en prod alcanza con setear la variable
 * en Netlify y volver a buildear — no hace falta tocar código.
 */

/**
 * TrainEase todavía no cobra (decisión del 11/08/2026).
 *
 * Los coaches nuevos arrancan en free tier con cupones de descuento, y los
 * alumnos de Enzo van gratis durante el cuatrimestre que estén con él. Recién
 * después se define cómo se pasa a pago.
 *
 * Mientras esto esté en `true` no se le muestra al coach ningún aviso sobre
 * vencimientos de prueba o suscripción. Sin el flag pasaba algo bastante malo:
 * 7 de los 11 coaches de prod tienen `trialExpired = 1` — incluidas las dos
 * cuentas reales de Enzo y la de Luciano —, así que `TrialBanner` les estaba
 * mostrando un banner ROJO de "tu prueba gratuita venció" sobre una app que por
 * decisión de negocio les es gratis.
 *
 * Ojo: el trial vencido NO bloquea el acceso — el check de `NotSubscribed` en
 * `PrivateRoute` está comentado. O sea que esto es puramente el mensaje.
 *
 * Cuando exista el modelo de planes (card #24), poner esto en `false` y revisar
 * los `trialEndsAt` de los coaches antes de volver a mostrar avisos.
 */
export const FREE_TIER_MODE: boolean = process.env.REACT_APP_FREE_TIER_MODE !== 'false';
